module.exports = __webpack_public_path__ + "files/afb99110882cd2a190d3624284fd9b72.png";